const DETAIL_PREFIX = 'catalog-detail__image-wrapper';
const CARD_PREFIX = 'catalog-card__image-wrapper';

export const getOrientationClasses = (prefix) => [`${prefix}--wide`, `${prefix}--tall`, `${prefix}--square`];

export const getOrientationClass = (prefix, width, height) => {
    if (!width || !height) {
        return '';
    }

    const ratio = width / height;

    if (ratio > 1.05) {
        return `${prefix}--wide`;
    }

    if (ratio < 0.95) {
        return `${prefix}--tall`;
    }

    return `${prefix}--square`;
};

export const applyImageOrientation = (wrapper, width, height, prefix) => {
    if (!wrapper || !width || !height) {
        return;
    }

    wrapper.classList.remove(...getOrientationClasses(prefix));

    const orientationClass = getOrientationClass(prefix, width, height);

    if (orientationClass) {
        wrapper.classList.add(orientationClass);
    }
};

export const updateImageOrientationFromImage = (wrapper, img, prefix) => {
    const apply = () => {
        applyImageOrientation(wrapper, img.naturalWidth, img.naturalHeight, prefix);
    };

    if (img.complete && img.naturalWidth) {
        apply();
        return;
    }

    img.addEventListener('load', apply, {once: true});
};

export const initCatalogCardImageOrientation = () => {
    document.querySelectorAll('.catalog-card__image-wrapper').forEach((wrapper) => {
        const img = wrapper.querySelector('.catalog-card__image');

        if (!img) {
            return;
        }

        const width = Number(img.getAttribute('width'));
        const height = Number(img.getAttribute('height'));

        if (width && height) {
            applyImageOrientation(wrapper, width, height, CARD_PREFIX);
            return;
        }

        updateImageOrientationFromImage(wrapper, img, CARD_PREFIX);
    });
};

export {DETAIL_PREFIX, CARD_PREFIX};
